export const district_data = {
  "type": "FeatureCollection",
  "crs": {
    "type": "name",
    "properties": {
      "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
    }
  },
  "features": [{
    "type": "Feature",
    "properties": {
      "FID": 2,
      "district": "bhaktapur",
      "id": null
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [85.36328125, 27.668882369995174],
            [85.354331970214844, 27.667764663696289],
            [85.358436584472713, 27.676090240478572],
            [85.357192993164062, 27.678203582763729],
            [85.359306335449219, 27.682428359985295],
            [85.362159729003906, 27.681434631347599],
            [85.369987487792969, 27.68827056884777],
            [85.372352600097713, 27.688890457153434],
            [85.374092102050895, 27.692371368408317],
            [85.376579284668082, 27.690505981445369],
            [85.378067016601619, 27.690755844116211],
            [85.378189086914062, 27.694482803344727],
            [85.380302429199219, 27.692993164062557],
            [85.383537292480469, 27.694110870361271],
            [85.387138366699219, 27.692371368408317],
            [85.387138366699219, 27.695974349975643],
            [85.389007568359489, 27.696596145629883],
            [85.391990661621151, 27.697217941284123],
            [85.390495300293082, 27.700820922851619],
            [85.391616821289119, 27.702188491821346],
            [85.395095825195426, 27.702686309814567],
            [85.397705078125057, 27.70069694519043],
            [85.398452758789119, 27.701566696167106],
            [85.398948669433594, 27.703432083129883],
            [85.404541015625057, 27.705419540405217],
            [85.405784606933707, 27.708152770996094],
            [85.410255432128906, 27.711509704589957],
            [85.414230346679688, 27.711757659912166],
            [85.414482116699276, 27.713249206543082],
            [85.412246704101676, 27.716604232788143],
            [85.413986206054801, 27.717473983764648],
            [85.41721343994152, 27.716232299804744],
            [85.417465209960938, 27.72008323669445],
            [85.422431945800781, 27.719711303711051],
            [85.423301696777457, 27.723440170288143],
            [85.429145812988338, 27.723564147949332],
            [85.430389404296989, 27.725055694580078],
            [85.44144439697277, 27.727788925170898],
            [85.441200256347713, 27.725801467895565],
            [85.445800781250114, 27.724309921264648],
            [85.448036193847713, 27.725303649902287],
            [85.451019287109375, 27.723812103271598],
            [85.453498840332031, 27.721574783325195],
            [85.455490112304744, 27.721948623657227],
            [85.457481384277457, 27.720457077026481],
            [85.459091186523494, 27.719587326049805],
            [85.461334228515625, 27.7205810546875],
            [85.464683532714957, 27.718467712402344],
            [85.467048645019531, 27.720333099365291],
            [85.470901489257812, 27.720333099365291],
            [85.471771240234489, 27.717473983764648],
            [85.478233337402457, 27.715982437133903],
            [85.478607177734489, 27.71722602844244],
            [85.482330322265625, 27.718593597412109],
            [85.489044189453182, 27.718593597412109],
            [85.499481201171875, 27.723190307617301],
            [85.505943298339787, 27.723564147949332],
            [85.517631530761719, 27.727664947509879],
            [85.522850036621151, 27.727912902832145],
            [85.527320861816406, 27.725179672241268],
            [85.521728515625114, 27.718219757080135],
            [85.523590087890682, 27.713745117187557],
            [85.522476196289176, 27.710142135620231],
            [85.523963928222713, 27.706413269042912],
            [85.523963928222713, 27.700325012207031],
            [85.522720336914006, 27.698335647583065],
            [85.523590087890682, 27.694110870361271],
            [85.522224426269588, 27.692619323730526],
            [85.515388488769588, 27.691625595092887],
            [85.508308410644588, 27.692495346069336],
            [85.505325317382926, 27.689016342163029],
            [85.504699707031307, 27.683174133300781],
            [85.500976562499943, 27.675346374511719],
            [85.498489379882926, 27.673357009887752],
            [85.498611450195369, 27.670001983642635],
            [85.496002197265739, 27.665279388427848],
            [85.49637603759777, 27.662794113159237],
            [85.493392944335938, 27.658195495605469],
            [85.493019104003906, 27.655710220337028],
            [85.495010375976676, 27.651981353759766],
            [85.4873046875, 27.647010803222713],
            [85.482330322265625, 27.641666412353459],
            [85.480224609375, 27.644773483276367],
            [85.478729248046875, 27.644153594970703],
            [85.478981018066463, 27.642412185668945],
            [85.479103088378906, 27.64067268371582],
            [85.474876403808594, 27.635080337524528],
            [85.471893310546932, 27.633464813232365],
            [85.466796875000114, 27.625635147094727],
            [85.462448120117131, 27.624393463134822],
            [85.461578369140682, 27.628122329711914],
            [85.456237792968807, 27.635578155517578],
            [85.449150085449219, 27.628618240356559],
            [85.442192077636832, 27.627250671386832],
            [85.440330505371037, 27.623523712158317],
            [85.437721252441406, 27.622653961181641],
            [85.43076324462902, 27.624517440796012],
            [85.425788879394645, 27.620292663574276],
            [85.420570373535213, 27.619794845581055],
            [85.409759521484489, 27.62899208068859],
            [85.408020019531307, 27.629611968994254],
            [85.406402587890625, 27.632347106933651],
            [85.398696899414176, 27.632719039917106],
            [85.395339965820312, 27.635578155517578],
            [85.39298248291027, 27.640922546386776],
            [85.391860961914176, 27.644773483276367],
            [85.389625549316406, 27.643531799316406],
            [85.386764526367188, 27.648750305175838],
            [85.376701354980526, 27.651361465454102],
            [85.374961853027344, 27.653596878051871],
            [85.373474121093807, 27.653224945068416],
            [85.371856689453068, 27.654466629028377],
            [85.371856689453068, 27.66005897521984],
            [85.367256164550895, 27.66005897521984],
            [85.365394592285156, 27.662546157837028],
            [85.363159179687557, 27.661054611206112],
            [85.365768432617188, 27.664781570434627],
            [85.36328125, 27.668882369995174]
          ]
        ]
      ]
    }
  }]
}
